import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {greys, fontColor} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import Hr from "@irati/ui/src/Layout/Hr"
import {Label2} from "@irati/ui/src/Labels"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import formatRelativeForOpenPolls from "@irati/recognition/utils/formatRelativeForOpenPolls"

const EndDateContainer = styled.div`
  margin-bottom: 10px;
`

const EndDateLabel = styled(Label2)`
  background-color: ${greys.white};
  padding: 0 ${padding.base};
  color: ${fontColor};
`

const EndDateLineThrough = styled(Hr)`
  margin-top: -10px;
`

const EndDate = ({endsAt, className, intl, poll}) => {
  return (
    <EndDateContainer className={className}>
      <EndDateLabel>
        {poll &&
          <FormattedMessage
            id="recognition.polls.closedPolls.createdAt"
            values={{time: formatRelativeForOpenPolls(endsAt, intl)}} />
        }
        {!poll && formatRelativeForOpenPolls(endsAt, intl)}
      </EndDateLabel>
      <EndDateLineThrough />
    </EndDateContainer>
  )
}

EndDate.propTypes = {
  endsAt: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  className: PropTypes.string,
  poll: PropTypes.bool
}

EndDate.defaultProps = {
  className: null,
  poll: false
}

export default injectIntl(EndDate)
